function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import MuiRadioGroup from "@mui/material/RadioGroup";
import MuiFormControlLabel from "@mui/material/FormControlLabel";
import MuiFormControl from "@mui/material/FormControl";
import MuiFormLabel from "@mui/material/FormLabel";
// @limitless
import Radio from "../radio-button/RadioButton";
import { useTranslation } from "@limitless/common/hooks";
const RadioGroup = ({
  items = [],
  labelledBy = "radio-buttons-group-label",
  inputControl = /*#__PURE__*/React.createElement(Radio, {
    radioButtonStyle: {
      padding: "2px 0px 2px 0",
      margin: "2px 8px 0px 2px"
    }
  }),
  defaultValue,
  title,
  onChange,
  row = false,
  titleId = "radio-buttons-group-label",
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(MuiFormControl, {
    sx: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(MuiFormLabel, {
    id: titleId
  }, t(title)), /*#__PURE__*/React.createElement(MuiRadioGroup, _extends({
    "aria-labelledby": labelledBy,
    defaultValue: defaultValue,
    name: "radio-buttons-group",
    onChange: onChange,
    sx: {
      padding: 0
    },
    row: row
  }, rest), items.map((item, index) => /*#__PURE__*/React.createElement(MuiFormControlLabel, {
    key: index,
    value: item.value,
    control: item.control || inputControl,
    label: t(item.label),
    sx: {
      width: "auto",
      marginRight: row ? 3 : 0
    },
    componentsProps: {
      typography: {
        variant: "body2"
      }
    },
    id: `${item.value}Radio`
  }))));
};
RadioGroup.propTypes = {
  items: PropTypes.array.isRequired,
  labelledBy: PropTypes.string,
  inputControl: PropTypes.node,
  defaultValue: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
  row: PropTypes.bool,
  titleId: PropTypes.string
};
export default RadioGroup;